import { OptionItem } from '@nv/react-akira'
import { useIntl } from 'hooks/common'
import { getTranslatedOptionItems } from 'utils/selectMappers'

export const useTranslateOptionItems = <T = string>(options: OptionItem<T>[]) => {
  const intl = useIntl()
  return getTranslatedOptionItems({ options, intl })
}
